<template>
  <v-container fluid class="pa-0 ml-8 mr-8">
    <v-row>
      <v-col cols="auto">
        <v-btn
          @click="changeMode('table')"
          icon="mdi-table"
          class="mx-3"
        ></v-btn>
        <v-btn
          @click="changeMode('tree')"
          icon="mdi-file-tree"
          class="mx-3"
        ></v-btn>
      </v-col>
      <v-col cols="9">
        <v-text-field
          v-if="mode == 'table'"
          v-model="search"
          :label="$t('search_by_meter')"
          variant="outlined"
          append-inner-icon="mdi-magnify"
          rounded
          class="mx-auto"
          width="50%"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>

  <v-container v-if="mode == 'tree'" fluid class="pa-0 ma-8">
    <tree-view :treeData="metersHierarchy"></tree-view>
  </v-container>
  <v-container v-if="mode == 'table'" fluid class="pa-0 ma-8 mt-0">
    <!-- <v-text-field
      v-model="search"
      :label="$t('search_by_meter')"
      variant="outlined"
      append-inner-icon="mdi-magnify"
    ></v-text-field> -->
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="filteredMeters"
      :sort-by="[{ key: 'name', order: 'asc' }]"
      class="elevation-3 rounded-lg"
    >
      <template v-slot:no-data>
        <h3>No data available</h3>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>العدادات</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <DialogMeter
            :item="item"
            :parents="parents"
            :saveFunction="save"
            mode="add"
            iconName="mdi-plus"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <DialogMeter
            :item="item"
            :parents="parents"
            :saveFunction="save"
            mode="edit"
            iconName="mdi-pencil"
          />

          <DialogSimp
            :v-model="dialogSimp"
            iconName="mdi-delete"
            :item="item"
            :confirmFunction="deleteItem"
            :message="messages.delete"
          />
        </v-row>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <v-container>
          <p>{{ $t(`${item.status}`) }}</p>
        </v-container>
      </template>
      <template v-slot:[`item.isFinal`]="{ item }">
        <v-container>
          <p>{{ item.isFinal == true ? $t("yes") : $t("no") }}</p>
        </v-container>
      </template>
      <template v-slot:[`item.parent_id`]="{ item }">
        <v-container>
          <p>{{ item.parent?.name }}</p>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
  <overlay-loader v-model="loading" />
</template>
<script>
import TreeView from "@/components/TreeView.vue";

import DialogMeter from "@/components/dialogs/DialogMeter.vue";
import DialogSimp from "@/components/DialogSimp.vue";

import repo from "@/store/repo.js";
import swalFun from "@/plugins/swalFun";
import OverlayLoader from "@/components/common/OverlayLoader.vue";

export default {
  components: {
    DialogMeter,
    DialogSimp,
    OverlayLoader,
    TreeView,
  },
  data: () => ({
    search: "",
    loading: false,
    headers: [
      { title: "الرقم", key: "code" },
      { title: "الاسم", key: "name" },
      { title: "الحالة", key: "status" },
      { title: "عداد زبون؟", key: "isFinal" },
      { title: "العداد الأب", key: "parent_id" },
      { title: "العمليات", key: "actions" },
    ],
    dialog: false,
    dialogSimp: false,
    editedIndex: -1,
    messages: {
      delete: "هل أنت متأكد",
    },
    mode: "table",
  }),
  computed: {
    meters() {
      let us = repo.meters.getAllMeters();
      console.log("meter info", us[0]);
      return us;
    },
    parents() {
      //return this.meters;
      return this.meters.filter((meter) => {
        return meter.isFinal == false;
      });
    },
    filteredMeters() {
      if (this.search.trim() == "") {
        return this.meters;
      }
      return this.meters.filter((meter) => {
        return meter.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    metersHierarchy() {
      const meters = this.meters;
      const meterMap = {};
      const rootMeters = [];

      // Create a map of meters using their IDs as keys
      meters.forEach((meter) => {
        meter.children = [];
        meterMap[meter.id] = meter;
      });

      // Iterate through the meters to build the hierarchy
      meters.forEach((meter) => {
        if (meter.parent_id && meterMap[meter.parent_id]) {
          meterMap[meter.parent_id].children.push(meter);
        } else {
          rootMeters.push(meter);
        }
      });

      return rootMeters;
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      const res = await repo.meters.fetchAll_lite();
      if (res) {
        //swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
      this.loading = false;
    },
    async save(formData, mode) {
      formData.isFinal = formData.isFinal ? 1 : 0;
      if (mode == "add") {
        //create a meter
        console.log("form", mode, formData);
        const res = await repo.meters.add(formData);
        if (res) {
          swalFun.success("success");
        } else {
          swalFun.fail("error");
        }
      } else {
        //update a meter
        formData.metername = formData.fullname;
        console.log("form", mode, formData);
        const res = await repo.meters.update(formData);
        if (res) {
          swalFun.success("success");
        } else {
          swalFun.fail("error");
        }
      }
    },
    async deleteItem(item) {
      const res = await repo.meters.delete(item.id);
      if (res) {
        swalFun.success("success");
      } else {
        swalFun.fail("error");
      }
      //console.log("item to delete:", item.id);
    },
    activateItem(item) {
      console.log("item to activate:", item);
    },
    deactivateItem(item) {
      console.log("item to deactivate:", item);
    },
    changeMode(mode) {
      this.mode = mode;
    },
  },
  async mounted() {
    await this.fetch();
  },
};
</script>
